module.exports = __webpack_public_path__ + "static/media/email-icon.f7ae03f2.svg";